// extracted by mini-css-extract-plugin
export default {"star-icon":"_hhp0jq","starIcon":"_hhp0jq","rating":"_1n73kkr"};